import React from "react";

const ModelsPage = (props) => {
	return <div>{props.children}</div>;
};

export default ModelsPage;
